<div *ngIf="initialized" class="flex flex-column gap-3 p-3">

    <!-- Project Header with Status Badge -->
    <div *ngIf="projectDto" class="flex align-items-center justify-content-between surface-card border-round-lg p-3">
        <div class="flex align-items-center gap-3">
            <i class="fa-regular fa-diagram-project text-2xl text-primary"></i>
            <div>
                <div class="text-2xl font-bold text-color">{{ projectDto.name }}</div>
                <div class="text-sm text-gray-600" *ngIf="projectDto.description">{{ projectDto.description }}</div>
            </div>
        </div>
        <div class="flex align-items-center gap-2">
            <p-tag [value]="getProjectStatusLabel()" [severity]="getProjectStatusSeverity()"></p-tag>
            <p-button
                icon="fa-regular fa-plus"
                label="Add Ticket"
                severity="secondary"
                [outlined]="true"
                size="small"
                (onClick)="openAddTicketDialog()">
            </p-button>
        </div>
    </div>

    <!-- Overview Section -->
    <ng-container *ngIf="activeNavItem === 'overview' || !activeNavItem">
        <div class="grid">
            <!-- Project Data Widget -->
            <div class="col-12">
                <mvs-widget
                    *ngIf="projectDataWidget"
                    [widgetData]="projectDataWidget">
                </mvs-widget>
            </div>

            <!-- Boards for this project -->
            <div class="col-12 md:col-6">
                <mvs-widget
                    *ngIf="boardWidget"
                    [widgetData]="boardWidget"
                    (onObjectSelect)="handleBoardSelect($event)">
                </mvs-widget>
            </div>

            <!-- Sprints for this project -->
            <div class="col-12 md:col-6">
                <mvs-widget
                    *ngIf="sprintWidget"
                    [widgetData]="sprintWidget">
                </mvs-widget>
            </div>
        </div>
    </ng-container>

    <!-- Board / Kanban Section -->
    <ng-container *ngIf="activeNavItem === 'board'">
        <mvs-sp-kanban-board
            [lanes]="mcpLanes"
            [tickets]="mcpTickets"
            [loading]="kanbanLoading"
            (onTicketMoved)="handleTicketMoved($event)"
            (onTicketClick)="handleTicketClick($event)">
        </mvs-sp-kanban-board>
    </ng-container>

    <!-- Sprints Section -->
    <ng-container *ngIf="activeNavItem === 'sprints'">
        <div class="grid">
            <!-- QL Widget for CRUD operations -->
            <div class="col-12">
                <mvs-widget
                    *ngIf="sprintWidget"
                    [widgetData]="sprintWidget">
                </mvs-widget>
            </div>

            <!-- MCP Sprint Cards with Action Buttons -->
            <div class="col-12" *ngIf="sprints && sprints.length > 0">
                <div class="surface-card border-round-lg p-3">
                    <div class="text-lg font-semibold mb-3">Sprint Actions</div>
                    <div class="flex flex-column gap-2">
                        <div *ngFor="let sprint of sprints"
                             class="flex align-items-center justify-content-between p-3 border-1 border-200 border-round-lg">
                            <div class="flex align-items-center gap-3">
                                <div class="flex flex-column">
                                    <span class="text-base font-semibold">{{ sprint.name }}</span>
                                    <span class="text-sm text-gray-500" *ngIf="sprint.goal">{{ sprint.goal }}</span>
                                </div>
                                <p-tag [value]="sprint.status"
                                       [severity]="getSprintStatusSeverity(sprint.status)">
                                </p-tag>
                            </div>
                            <div class="flex align-items-center gap-3">
                                <div class="flex align-items-center gap-2 text-sm text-gray-600">
                                    <span *ngIf="sprint.startDate">{{ sprint.startDate }}</span>
                                    <span *ngIf="sprint.startDate && sprint.endDate"> - </span>
                                    <span *ngIf="sprint.endDate">{{ sprint.endDate }}</span>
                                </div>
                                <div class="flex align-items-center gap-2 text-sm text-gray-600">
                                    <span *ngIf="sprint.ticketCount != null">
                                        <i class="fa-regular fa-ticket mr-1"></i>{{ sprint.ticketCount }}
                                    </span>
                                    <span *ngIf="sprint.totalStoryPoints != null">
                                        <i class="fa-regular fa-star mr-1"></i>{{ sprint.totalStoryPoints }} pts
                                    </span>
                                </div>
                                <div class="flex align-items-center gap-2">
                                    <p-button
                                        *ngIf="sprint.status?.toLowerCase() === 'planned'"
                                        icon="fa-regular fa-play"
                                        label="Start"
                                        severity="info"
                                        [outlined]="true"
                                        size="small"
                                        (onClick)="handleStartSprint(sprint)">
                                    </p-button>
                                    <p-button
                                        *ngIf="sprint.status?.toLowerCase() === 'active'"
                                        icon="fa-regular fa-check"
                                        label="Complete"
                                        severity="success"
                                        [outlined]="true"
                                        size="small"
                                        (onClick)="handleCompleteSprint(sprint)">
                                    </p-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Tickets Section -->
    <ng-container *ngIf="activeNavItem === 'tickets'">
        <div class="grid">
            <div class="col-12">
                <div class="flex align-items-center justify-content-between mb-3">
                    <span class="text-lg font-semibold">Project Tickets</span>
                    <p-button
                        icon="fa-regular fa-plus"
                        label="Add Existing Ticket"
                        severity="secondary"
                        [outlined]="true"
                        size="small"
                        (onClick)="openAddTicketDialog()">
                    </p-button>
                </div>
                <mvs-widget
                    *ngIf="ticketWidget"
                    [widgetData]="ticketWidget">
                </mvs-widget>
            </div>
        </div>
    </ng-container>

</div>

<!-- Loading State -->
<div *ngIf="!initialized" class="flex flex-column gap-3 p-3">
    <p-skeleton height="4rem" class="mb-3"></p-skeleton>
    <p-skeleton height="20rem"></p-skeleton>
</div>

<!-- Add Ticket to Project Dialog -->
<p-dialog
    header="Add Existing Ticket"
    [(visible)]="showAddTicketDialog"
    [modal]="true"
    [style]="{'width': '40rem'}"
    [closable]="true"
    [draggable]="false">

    <div class="flex flex-column gap-3">
        <!-- Search Input -->
        <div class="flex flex-column gap-2">
            <label class="text-base font-medium">Search Tickets</label>
            <div class="flex gap-2">
                <input
                    pInputText
                    type="text"
                    [(ngModel)]="ticketSearchTerm"
                    placeholder="Enter ticket name (min 2 characters)..."
                    class="flex-1"
                    (keyup.enter)="searchTickets()">
                <p-button
                    icon="fa-regular fa-search"
                    severity="secondary"
                    [loading]="ticketSearchLoading"
                    (onClick)="searchTickets()">
                </p-button>
            </div>
        </div>

        <!-- Search Results -->
        <div *ngIf="ticketSearchResults.length > 0" class="flex flex-column gap-1" style="max-height: 20rem; overflow-y: auto;">
            <div *ngFor="let ticket of ticketSearchResults"
                 class="flex align-items-center gap-3 p-2 border-round-lg cursor-pointer"
                 [class.bg-primary-50]="selectedTicketId === ticket.id"
                 [class.border-1]="selectedTicketId === ticket.id"
                 [class.border-primary]="selectedTicketId === ticket.id"
                 [class.surface-hover]="selectedTicketId !== ticket.id"
                 (click)="selectedTicketId = ticket.id">
                <i class="fa-regular fa-ticket text-gray-500"></i>
                <div class="flex flex-column">
                    <span class="text-base font-medium">{{ ticket.name || 'Ticket #' + ticket.id }}</span>
                    <span class="text-sm text-gray-500" *ngIf="ticket.alias">{{ ticket.alias }}</span>
                </div>
            </div>
        </div>

        <!-- No results message -->
        <div *ngIf="ticketSearchTerm && ticketSearchTerm.length >= 2 && !ticketSearchLoading && ticketSearchResults.length === 0"
             class="text-center text-gray-500 p-3">
            No tickets found matching "{{ ticketSearchTerm }}".
        </div>
    </div>

    <ng-template #footer>
        <div class="flex justify-content-end gap-2">
            <p-button
                label="Cancel"
                severity="secondary"
                [text]="true"
                (onClick)="showAddTicketDialog = false">
            </p-button>
            <p-button
                label="Add to Project"
                icon="fa-regular fa-plus"
                [disabled]="!selectedTicketId"
                [loading]="addingTicket"
                (onClick)="addSelectedTicketToProject()">
            </p-button>
        </div>
    </ng-template>
</p-dialog>
